import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const OPEN_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL = 'OPEN_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL';
export const CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL = 'CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL';
export const CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR = 'CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR';
export const GET_CUSTOMER_LEGAL_ENTITIES_REQUEST = 'GET_CUSTOMER_LEGAL_ENTITIES_REQUEST';
export const GET_CUSTOMER_LEGAL_ENTITIES_SUCCESS = 'GET_CUSTOMER_LEGAL_ENTITIES_SUCCESS';
export const GET_CUSTOMER_LEGAL_ENTITIES_ERROR = 'GET_CUSTOMER_LEGAL_ENTITIES_ERROR';

function openEditCustomerLegalEntitiesModal(currentForm) {
  return {
    type: OPEN_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL,
    isEditCustomerLegalEntitiesModalShown: true,
    currentForm
  };
}

function closeEditCustomerLegalEntitiesModal() {
  return {
    type: CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL,
    isEditCustomerLegalEntitiesModalShown: false,
    editCustomerLegalEntitiesResponse: null,
    editCustomerLegalEntities: null
  };
}

function closeEditCustomerLegalEntitiesError() {
  return {
    type: CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR,
    isEditCustomerLegalEntitiesModalShown: true
  };
}

function requestGetCustomerLegalEntities() {
  return {
    type: GET_CUSTOMER_LEGAL_ENTITIES_REQUEST
  };
}

function receiveGetCustomerLegalEntities(legalEntityList) {
  return {
    type: GET_CUSTOMER_LEGAL_ENTITIES_SUCCESS,
    legalEntityList
  };
}

function rejectGetCustomerLegalEntities() {
  return {
    type: GET_CUSTOMER_LEGAL_ENTITIES_ERROR
  };
}

export function getCustomerLegalEntities(customerId) {
  return (dispatch) => {
    dispatch(requestGetCustomerLegalEntities());

    const promise = () => ApiService
      .getCustomerLegalEntities(customerId)
      .then(response => dispatch(receiveGetCustomerLegalEntities(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCustomerLegalEntities, true));
        }
      });
    return promise();
  };
}

export function showEditCustomerLegalEntitiesModal(currentForm) {
  return (dispatch) => {
    if (currentForm && currentForm.length > 0) {
      dispatch(getCustomerLegalEntities(currentForm[0].customerDbId));
    }
    return dispatch(openEditCustomerLegalEntitiesModal(currentForm));
  };
}

export function hideEditCustomerLegalEntitiesModal() {
  return (dispatch) => {
    dispatch(closeEditCustomerLegalEntitiesModal());
  };
}

export function hideEditCustomerLegalEntitiesError() {
  return (dispatch) => {
    dispatch(closeEditCustomerLegalEntitiesError());
  };
}
